import { render, staticRenderFns } from "./all.vue?vue&type=template&id=a5889c8e"
import script from "./all.vue?vue&type=script&lang=ts"
export * from "./all.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports